module.exports = __webpack_public_path__ + "img/banner2.5fb9fa24.png";